module.exports = __webpack_public_path__ + "static/media/promotion.8627a2a6.jpeg";